//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatCoords } from '../../pages/main/sections/UserSettings/UserSettingsGUI.js'

export default {
  props: {
    request: {
      type: Object,
      required: true
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      rows: [],
      pagination: {
        rowsPerPage: 0
      },
      columns: [
        {
          name: 'label',
          label: 'Поле',
          field: 'label',
          align: 'left'
        },
        {
          name: 'oldText',
          label: 'Старое значение',
          field: 'oldText',
          align: 'left'
        },
        {
          name: 'newText',
          label: 'Новое значение',
          field: 'newText',
          align: 'left'
        }
      ]
    }
  },
  computed: {
    canContinue: function () {
      const selected = this.rows.filter(row => row.selected)
      if (!selected.length) {
        return false
      }
      return selected.every(row => row.key !== 'serviceObject' || (row.selectedServiceObject && row.selectedServiceObject.id != null))
    }
  },
  created: function () {
    this.rows = this.buildRows()
  },
  methods: {
    buildRows: function () {
      const data = this.request.supRequestActualization || {}
      const rows = []

      if (data.comment != null) {
        const editable = this.commentEditable()
        rows.push({
          key: 'comment',
          label: 'Описание от заявителя',
          editable,
          selected: editable,
          oldText: this.request.applicantDescription || 'Не указано',
          newText: data.comment || 'Не указано',
          newValue: data.comment
        })
      }

      if (data.lon != null || data.lat != null) {
        const editable = this.locationEditable()
        const location = { lon: data.lon, lat: data.lat }
        rows.push({
          key: 'location',
          label: 'Координаты неисправности',
          editable,
          selected: editable,
          oldText: this.formatLocation(this.request.location),
          newText: this.formatLocation(location),
          lon: data.lon,
          lat: data.lat
        })
      }

      if (data.address != null) {
        const editable = this.addressEditable()
        rows.push({
          key: 'address',
          label: 'Адрес неисправности',
          editable,
          selected: editable,
          oldText: this.request.requestAddress || 'Не указан',
          newText: data.address || 'Не указан',
          newValue: data.address
        })
      }

      if (Array.isArray(data.serviceObjects) && data.serviceObjects.length) {
        const editable = this.serviceObjectEditable()
        rows.push({
          key: 'serviceObject',
          label: 'Объект обслуживания',
          editable,
          selected: editable,
          oldText: this.request.serviceObject ? this.serviceObjectLabel(this.request.serviceObject) : 'Не указан',
          serviceObjects: data.serviceObjects,
          selectedServiceObject: data.serviceObjects[0]
        })
      }

      return rows
    },
    commentEditable: function () {
      const isRequestCreation = this.taskStatus === 'BS0'
      const sourceKey = this.request.requestSource && this.request.requestSource.key
      const applicantDescriptionReadonly = !this.requestRoles.hasEditAccess ||
        !(isRequestCreation || ((this.taskStatus === 'BS1' || this.taskStatus === 'BS2') && sourceKey === 'deltaSDPEmployee'))
      return !applicantDescriptionReadonly && !this.isFieldReadonly('applicantDescription')
    },
    locationEditable: function () {
      return !!this.requestRoles.hasEditAccess && this.isFieldIncluded('location')
    },
    addressEditable: function () {
      return !!this.requestRoles.hasEditAccess && this.isFieldIncluded('requestAddress')
    },
    serviceObjectEditable: function () {
      return !!this.requestRoles.hasEditAccess && this.isFieldIncluded('serviceObject')
    },
    isFieldIncluded: function (key) {
      return !!(this.request.isFieldIncluded && this.request.isFieldIncluded(key))
    },
    isFieldReadonly: function (key) {
      return !!(this.request._configuration && this.request._configuration.isFieldReadonly && this.request._configuration.isFieldReadonly(key))
    },
    formatLocation: function (location) {
      if (!location || (location.lon == null && location.lat == null)) {
        return 'Не указаны'
      }
      const coordinateOrderLonLat = this.$store.getters.getUserSetting('ui.common.coordinateOrder', 'lonlat') === 'lonlat'
      return formatCoords(location, coordinateOrderLonLat)
    },
    serviceObjectLabel: function (object) {
      if (!object) {
        return ''
      }
      return object.alias || object.name || object.key || ''
    },
    openServiceObject: function (object) {
      if (!object || object.id == null) {
        return
      }
      const type = object.type && typeof object.type === 'object' ? object.type.key : object.type
      if (type) {
        this.$d_showObjectCard(object.id, type, true)
      }
    },
    onContinue: function () {
      const properties = {}
      const fields = []

      this.rows.forEach(row => {
        if (!row.editable || !row.selected) {
          return
        }
        if (row.key === 'comment') {
          properties.applicantDescr = row.newValue
          fields.push({ label: row.label, value: row.newText })
        } else if (row.key === 'address') {
          properties.requestAddress = row.newValue
          fields.push({ label: row.label, value: row.newText })
        } else if (row.key === 'location') {
          properties.requestLocation = { lon: row.lon, lat: row.lat }
          fields.push({ label: row.label, value: row.newText })
        } else if (row.key === 'serviceObject' && row.selectedServiceObject) {
          properties.serviceObjectId = Number(row.selectedServiceObject.id)
          fields.push({ label: row.label, value: this.serviceObjectLabel(row.selectedServiceObject) })
        }
      })

      this.$emit('continue', { properties, fields })
    }
  }
}

